import { render, staticRenderFns } from "./RawColumn.vue?vue&type=template&id=3453b76c&scoped=true&"
import script from "./RawColumn.vue?vue&type=script&lang=js&"
export * from "./RawColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3453b76c",
  null
  
)

export default component.exports